import { Text } from '@/components/ui';
import type { Message } from '@/lib/chat/types';

type ChatUsageMeterProps = {
  message: Message | null;
  compact?: boolean;
};

function formatTokens(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return String(value);
}

function formatCost(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }
  if (value < 0.01) {
    return `$${value.toFixed(4)}`;
  }
  return `$${value.toFixed(3)}`;
}

export function ChatUsageMeter({ message, compact }: ChatUsageMeterProps) {
  if (!message) {
    return compact ? null : (
      <Text variant="caption" className="text-muted">
        No usage data yet
      </Text>
    );
  }

  const line = `${formatTokens(message.contextTokens)} ctx · ${formatTokens(message.promptTokens)} in · ${formatTokens(message.completionTokens)} out · ${formatCost(message.cost)}`;

  return (
    <Text variant="caption" className={compact ? 'min-w-0 truncate text-muted' : 'text-muted'}>
      {line}
    </Text>
  );
}
